<p-toast></p-toast>
<app-header />
<div class="forget border border-primary">
  <div class="forget_top text-center">
    <div class="bg_1 inline_padding2 forget_top_box">
      <div class="forget_top_box_inner">
        <div class="inline_padding3">
          <span class="text_style_5">Forgot Password</span>
        </div>
      </div>
    </div>
  </div>
  <form
    [formGroup]="forgotPasswordForm"
    (ngSubmit)="submitforgetpasswordform()"
  >
    <div class="forget_section">
      <div class="forget_section_container">
        <div class="dis-block-1 p-top-18">
          <label for="email" class="dis-flex-4 text_grey_2"
            >Email Address</label
          >
          <input
            type="email"
            id="email"
            formControlName="email"
            class="dis-flex-4 text_grey_3 height-40 border-radius-4 width-100-per p-x-15"
            placeholder="Enter your email"
          />
          <div
            class="text_align"
            *ngIf="
              forgotPasswordForm.controls['email']?.invalid &&
              forgotPasswordForm.controls['email']?.touched
            "
          >
            <small
              *ngIf="forgotPasswordForm.controls['email']?.errors?.['required']"
              class="text-red-1"
              >Email address is required.</small
            >
            <small
              *ngIf="forgotPasswordForm.controls['email']?.errors?.['email']"
              class="text-red-1"
              >Invalid email format.</small
            >
          </div>
        </div>

        <div class="m-t-20 m-b-16">
          <re-captcha
            #recaptchaRef
            class="m-t-20"
            [siteKey]="recaptchaSiteKey"
            (resolved)="onCaptchaSuccess($event)"
          >
          </re-captcha>
          <div *ngIf="formSubmitted && !recaptchaResponse">
            <small class="text-red-1">Please complete the reCAPTCHA.</small>
          </div>
        </div>

        <div class="p-x-20 forget_section_bottom_head_btn p-top-40 dis-flex-2">
          <button type="submit" class="text_white_7 button_blue_4">Send</button>
        </div>
      </div>
    </div>
  </form>

  <div class="p-top-132 m-t-25-neg"></div>
</div>

<app-footer />
